var _path, _g, _path2, _g2, _path3, _g3, _path4, _circle, _circle2, _path5, _path6, _circle3, _circle4, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoCostard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 130,
    viewBox: "0 0 88 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15167_19561",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 36,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27734 16.4526H40.8003V52.352H5.27734V16.4526Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15167_19561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1186 52.0804L38.3004 52.0708C27.5775 51.9989 19.2374 48.8404 13.5099 42.667C4.54306 33.0092 5.35171 19.5889 5.38999 19.0233L5.49525 17.4656L7.05991 17.3553C7.05991 17.3553 7.50012 17.3218 8.27527 17.3218C13.5578 17.3218 39.9081 18.913 40.1091 50.2591L40.1186 52.0804Z",
    fill: "url(#paint0_linear_15167_19561)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15167_19561",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 16,
    width: 36,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1484 16.4526H83.6714V52.352H48.1484V16.4526Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15167_19561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7734 52.0804L48.7878 50.2591C48.9888 18.913 75.3391 17.3218 80.6168 17.3218C81.3967 17.3218 81.837 17.3553 81.837 17.3553L83.3968 17.4656L83.5069 19.0233C83.5452 19.5889 84.3538 33.0044 75.3869 42.667C69.6642 48.8404 61.3194 51.9989 50.5917 52.0708L48.7734 52.0804Z",
    fill: "url(#paint1_linear_15167_19561)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15167_19561",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 51,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0664 25.1187L43.1849 0.000134493L68.5696 25.3848L43.4511 50.5033L18.0664 25.1187Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15167_19561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.707 49.8696L42.4292 48.5715C20.4064 26.2644 37.9137 6.50675 41.6456 2.77484C42.1971 2.22334 42.5321 1.93579 42.5321 1.93579L43.713 0.91075L44.8923 1.9344C45.3193 2.30725 55.3773 11.2217 55.8693 24.3947C56.1879 32.8065 52.5207 40.9406 44.9859 48.5771L43.707 49.8696Z",
    fill: "url(#paint2_linear_15167_19561)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1205 96.4277C85.515 110.059 86.2123 116.875 83.1439 121.783C82.0935 123.462 80.7555 124.944 79.1912 126.16C74.6216 129.712 67.7702 129.712 54.0674 129.712H33.8384C19.9958 129.712 13.0745 129.712 8.48771 126.114C6.9183 124.883 5.57955 123.383 4.5336 121.685C1.47665 116.721 2.25835 109.844 3.82175 96.0902L7.50207 63.7126C8.77459 52.5176 9.41085 46.9201 12.5878 43.0625C13.6846 41.7307 14.9792 40.5749 16.4265 39.6355C20.6181 36.9146 26.2517 36.9146 37.5187 36.9146H50.7551C62.1395 36.9146 67.8317 36.9146 72.0454 39.6764C73.4996 40.6295 74.7978 41.8017 75.894 43.1513C79.0703 47.0621 79.6496 52.7247 80.8082 64.05L84.1205 96.4277Z",
    fill: "url(#paint3_linear_15167_19561)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0156,
    cy: 48.3316,
    r: 16.6875,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6475,
    cy: 51.5571,
    r: 10.6983,
    fill: "#3D1F1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.624 58.0021C22.624 55.7577 24.2945 54.1398 26.4864 54.1398C24.3964 54.1398 22.6258 52.4164 22.6258 50.2757C22.6258 52.396 20.9735 54.1398 18.7617 54.1398C20.9735 54.1398 22.624 55.8392 22.624 58.0021Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.624 50.2739L22.6258 50.2757M22.6258 50.2757C22.6258 52.4164 24.3964 54.1398 26.4864 54.1398C24.2945 54.1398 22.624 55.7577 22.624 58.0021C22.624 55.8392 20.9735 54.1398 18.7617 54.1398C20.9735 54.1398 22.6258 52.396 22.6258 50.2757Z",
    stroke: "white",
    strokeWidth: 2.7699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.8281,
    cy: 48.3316,
    r: 16.6875,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.4561,
    cy: 51.5571,
    r: 10.6983,
    fill: "#3D1F1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7022 58.0021C64.7022 55.7577 66.3726 54.1398 68.5645 54.1398C66.4745 54.1398 64.7039 52.4164 64.7039 50.2757C64.7039 52.396 63.0516 54.1398 60.8398 54.1398C63.0516 54.1398 64.7022 55.8392 64.7022 58.0021Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7022 50.2739L64.7039 50.2757M64.7039 50.2757C64.7039 52.4164 66.4745 54.1398 68.5645 54.1398C66.3726 54.1398 64.7022 55.7577 64.7022 58.0021C64.7022 55.8392 63.0516 54.1398 60.8398 54.1398C63.0516 54.1398 64.7039 52.396 64.7039 50.2757Z",
    stroke: "white",
    strokeWidth: 2.7699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1651 92.8276H7.38281L22.979 127.637H46.7447L80.1651 92.8276Z",
    fill: "url(#paint4_linear_15167_19561)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2366 115.094C48.3328 117.077 48.3809 118.068 48.0339 118.833C47.7099 119.547 47.1538 120.131 46.4561 120.489C45.7088 120.873 44.7162 120.873 42.7312 120.873C40.7365 120.873 39.7391 120.873 38.9898 120.487C38.2903 120.126 37.7338 119.539 37.4115 118.821C37.0662 118.052 37.1198 117.056 37.2272 115.064L38.0722 99.3916C38.131 98.3012 38.1604 97.7561 38.3096 97.3102C38.6767 96.2124 39.5663 95.3695 40.6823 95.0619C41.1355 94.937 41.6815 94.937 42.7734 94.937C43.8707 94.937 44.4193 94.937 44.8741 95.0628C45.9938 95.3726 46.8848 96.2213 47.2484 97.3248C47.3961 97.7729 47.4227 98.3209 47.4759 99.4169L48.2366 115.094Z",
    fill: "#FD3C4F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2366 115.094C48.3328 117.077 48.3809 118.068 48.0339 118.833C47.7099 119.547 47.1538 120.131 46.4561 120.489C45.7088 120.873 44.7162 120.873 42.7312 120.873C40.7365 120.873 39.7391 120.873 38.9898 120.487C38.2903 120.126 37.7338 119.539 37.4115 118.821C37.0662 118.052 37.1198 117.056 37.2272 115.064L38.0722 99.3916C38.131 98.3012 38.1604 97.7561 38.3096 97.3102C38.6767 96.2124 39.5663 95.3695 40.6823 95.0619C41.1355 94.937 41.6815 94.937 42.7734 94.937C43.8707 94.937 44.4193 94.937 44.8741 95.0628C45.9938 95.3726 46.8848 96.2213 47.2484 97.3248C47.3961 97.7729 47.4227 98.3209 47.4759 99.4169L48.2366 115.094Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9584 93.5231C50.1056 94.2983 50.1791 94.6858 50.1889 95.002C50.2515 97.0305 48.7955 98.7889 46.7909 99.1056C46.4785 99.155 46.084 99.155 45.295 99.155H40.2662C39.4627 99.155 39.061 99.155 38.745 99.1045C36.7157 98.7801 35.2559 96.9802 35.3572 94.9276C35.373 94.6081 35.4559 94.215 35.6217 93.4288C35.7356 92.889 35.7925 92.6192 35.8717 92.3874C36.3712 90.9258 37.6625 89.8785 39.1957 89.6913C39.4389 89.6616 39.7146 89.6616 40.2662 89.6616H45.295C45.8572 89.6616 46.1382 89.6616 46.385 89.6922C47.9419 89.8851 49.2453 90.9643 49.7251 92.458C49.8012 92.6947 49.8536 92.9709 49.9584 93.5231Z",
    fill: "url(#paint5_linear_15167_19561)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9584 93.5231C50.1056 94.2983 50.1791 94.6858 50.1889 95.002C50.2515 97.0305 48.7955 98.7889 46.7909 99.1056C46.4785 99.155 46.084 99.155 45.295 99.155H40.2662C39.4627 99.155 39.061 99.155 38.745 99.1045C36.7157 98.7801 35.2559 96.9802 35.3572 94.9276C35.373 94.6081 35.4559 94.215 35.6217 93.4288C35.7356 92.889 35.7925 92.6192 35.8717 92.3874C36.3712 90.9258 37.6625 89.8785 39.1957 89.6913C39.4389 89.6616 39.7146 89.6616 40.2662 89.6616H45.295C45.8572 89.6616 46.1382 89.6616 46.385 89.6922C47.9419 89.8851 49.2453 90.9643 49.7251 92.458C49.8012 92.6947 49.8536 92.9709 49.9584 93.5231Z",
    fill: "#FD3C4F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2467 96.5662C85.6491 110.154 86.3493 116.949 83.2636 121.841C82.2073 123.515 80.8617 124.992 79.2888 126.204C74.6933 129.744 67.803 129.744 54.0228 129.744H33.6795C19.759 129.744 12.7983 129.745 8.18564 126.159C6.60741 124.932 5.26165 123.436 4.2098 121.743C1.13558 116.795 1.92176 109.94 3.49398 96.2304L4.83342 84.5423L42.7198 118.669L82.9891 84.3872L84.2467 96.5662Z",
    fill: "url(#paint6_linear_15167_19561)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2467 96.5662C85.6491 110.154 86.3493 116.949 83.2636 121.841C82.2073 123.515 80.8617 124.992 79.2888 126.204C74.6933 129.744 67.803 129.744 54.0228 129.744H33.6795C19.759 129.744 12.7983 129.745 8.18564 126.159C6.60741 124.932 5.26165 123.436 4.2098 121.743C1.13558 116.795 1.92176 109.94 3.49398 96.2304L4.83342 84.5423L42.7198 118.669L82.9891 84.3872L84.2467 96.5662Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 73.1604C29.0241 71.5926 29.3531 70.4536 30.0474 69.6898C31.5208 68.0689 34.0708 68.7445 36.1762 69.3493C38.3277 69.9674 40.914 70.6918 42.6815 70.9655C46.2413 71.5167 50.4472 69.0739 51.9713 68.4621C53.4955 67.8503 57.8018 67.574 57.2608 72.708C56.7198 77.8419 49.6698 82.2552 42.2884 82.2552C34.4884 82.2552 31.3349 77.3816 29.65 73.1604Z",
    fill: "#3D1F1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15167_19561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 68,
    width: 29,
    height: 15
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 73.1643C29.0241 71.5965 29.3531 70.4575 30.0474 69.6937C31.5208 68.0728 34.0708 68.7484 36.1762 69.3532C38.3277 69.9713 40.914 70.6957 42.6815 70.9694C46.2413 71.5206 50.4472 69.0778 51.9713 68.466C53.4955 67.8542 57.8018 67.5779 57.2608 72.7119C56.7198 77.8458 49.6698 82.2591 42.2884 82.2591C34.4884 82.2591 31.3349 77.3855 29.65 73.1643Z",
    fill: "#3D1F1E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15167_19561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4863 75.5356C39.8614 75.5357 40.2342 75.5695 40.6045 75.6372C40.9726 75.705 41.3318 75.8065 41.6807 75.939C42.0294 76.0714 42.3592 76.2322 42.6719 76.4263C42.9845 76.6173 43.2755 76.8361 43.54 77.0825C43.6596 77.1915 43.7728 77.306 43.8809 77.4243C43.9839 77.3541 44.089 77.2862 44.1973 77.2222C44.5203 77.0281 44.8639 76.8674 45.2217 76.7349C45.5818 76.6024 45.9525 76.5009 46.335 76.4331C46.715 76.3654 47.1003 76.3315 47.4902 76.3315C47.8777 76.3316 48.263 76.3653 48.6455 76.4331C49.0255 76.5009 49.3957 76.6024 49.7559 76.7349C50.1161 76.8673 50.4563 77.0281 50.7793 77.2222C51.1023 77.4132 51.4034 77.6319 51.6768 77.8784C51.9524 78.1217 52.198 78.3899 52.4141 78.6763C52.6302 78.9659 52.8119 79.2679 52.9609 79.5884C53.11 79.9088 53.2218 80.2387 53.2988 80.5776C53.3733 80.9196 53.4131 81.2618 53.4131 81.6099C53.4131 81.9547 53.3733 82.2964 53.2988 82.6382C53.2218 82.9771 53.11 83.307 52.9609 83.6274C52.8119 83.9479 52.6302 84.2499 52.4141 84.5396C52.198 84.826 51.9524 85.0941 51.6768 85.3374C51.4034 85.5839 51.1023 85.8026 50.7793 85.9937C50.4563 86.1878 50.1161 86.3485 49.7559 86.481C49.3957 86.6134 49.0255 86.7149 48.6455 86.7827C48.263 86.8505 47.8777 86.8843 47.4902 86.8843C47.1003 86.8843 46.715 86.8504 46.335 86.7827C45.9524 86.7149 45.5819 86.6134 45.2217 86.481C44.8639 86.3485 44.5203 86.1878 44.1973 85.9937C43.8744 85.8027 43.574 85.5838 43.3008 85.3374C43.1814 85.232 43.0683 85.1214 42.96 85.0073C42.8658 85.0731 42.7704 85.1375 42.6719 85.1978C42.3592 85.3918 42.0294 85.5526 41.6807 85.6851C41.3318 85.8175 40.9726 85.919 40.6045 85.9868C40.2342 86.0545 39.8615 86.0884 39.4863 86.0884C39.1086 86.0884 38.7353 86.0546 38.3672 85.9868C37.9967 85.919 37.6379 85.8175 37.2891 85.6851C36.9426 85.5526 36.6106 85.3918 36.2979 85.1978C35.9852 85.0068 35.6943 84.7879 35.4297 84.5415C35.1626 84.2981 34.9242 84.0302 34.7148 83.7437C34.5055 83.4541 34.3299 83.1519 34.1855 82.8315C34.0412 82.5112 33.933 82.1811 33.8584 81.8423C33.7863 81.5005 33.75 81.1588 33.75 80.814C33.75 80.4659 33.7863 80.1237 33.8584 79.7817C33.933 79.4428 34.0412 79.1129 34.1855 78.7925C34.3299 78.472 34.5055 78.17 34.7148 77.8804C34.9242 77.5938 35.1626 77.3259 35.4297 77.0825C35.6943 76.8361 35.9852 76.6173 36.2979 76.4263C36.6106 76.2322 36.9426 76.0714 37.2891 75.939C37.6379 75.8065 37.9967 75.705 38.3672 75.6372C38.7353 75.5694 39.1086 75.5356 39.4863 75.5356Z",
    fill: "#FA5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15167_19561",
    x1: 22.7371,
    y1: 17.3218,
    x2: 22.7371,
    y2: 52.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15167_19561",
    x1: 66.1574,
    y1: 17.3218,
    x2: 66.1574,
    y2: 52.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15167_19561",
    x1: 31.4212,
    y1: 12.9992,
    x2: 55.9993,
    y2: 37.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15167_19561",
    x1: 44.2902,
    y1: 36.9146,
    x2: 44.2902,
    y2: 129.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.361238,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678936,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15167_19561",
    x1: 43.774,
    y1: 92.8276,
    x2: 43.774,
    y2: 127.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E6E6",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15167_19561",
    x1: 42.8208,
    y1: 89.6616,
    x2: 42.8208,
    y2: 99.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15167_19561",
    x1: 43.7746,
    y1: 84.3872,
    x2: 43.7746,
    y2: 129.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D788B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoCostard);
export default __webpack_public_path__ + "static/media/pikko-costard.385434bd66cc6a8ab52d527c5e944ec5.svg";
export { ForwardRef as ReactComponent };